import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=7c2b1577&scoped=true&"
import script from "./Detail.vue?vue&type=script&lang=js&"
export * from "./Detail.vue?vue&type=script&lang=js&"
import style0 from "./Detail.vue?vue&type=style&index=0&id=7c2b1577&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2b1577",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c2b1577')) {
      api.createRecord('7c2b1577', component.options)
    } else {
      api.reload('7c2b1577', component.options)
    }
    module.hot.accept("./Detail.vue?vue&type=template&id=7c2b1577&scoped=true&", function () {
      api.rerender('7c2b1577', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/progressbar/ProgressUpdate/Detail.vue"
export default component.exports